import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
    pdfFile: string;
}

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrl: './pdf-viewer.component.scss',
})
export class PDFViewerComponent {
    constructor(
        public dialogRef: MatDialogRef<PDFViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {}
}
